import { z } from "zod";
import { REPORT_RESOURCE_TYPE_VALUES } from "../enum.js";

export const REPORT_STATUS_VALUES = ["pending", "resolved_removed", "resolved_banned", "resolved_group_deleted", "dismissed"] as const;
export const ReportStatus = {
	PENDING: "pending",
	RESOLVED_REMOVED: "resolved_removed",
	RESOLVED_BANNED: "resolved_banned",
	RESOLVED_GROUP_DELETED: "resolved_group_deleted",
	DISMISSED: "dismissed",
} as const;
export type ReportStatus = (typeof REPORT_STATUS_VALUES)[number];

export const listAdminReportsQuerySchema = z.object({
	limit: z.coerce.number().int().min(1).max(200).default(50),
	offset: z.coerce.number().int().min(0).default(0),
	status: z.enum(REPORT_STATUS_VALUES).optional(),
	resource_type: z.enum(REPORT_RESOURCE_TYPE_VALUES).optional(),
});
export type ListAdminReportsQuery = z.infer<typeof listAdminReportsQuerySchema>;

export const removeReportedContentSchema = z.object({
	note: z.string().trim().max(500).optional(),
});
export type RemoveReportedContentPayload = z.infer<typeof removeReportedContentSchema>;

export const banReportedAuthorSchema = z.object({
	reason: z.string().trim().max(500).optional(),
	also_delete_content: z.boolean().default(false),
});
export type BanReportedAuthorPayload = z.infer<typeof banReportedAuthorSchema>;

export const deleteReportedGroupSchema = z.object({
	note: z.string().trim().max(500).optional(),
});
export type DeleteReportedGroupPayload = z.infer<typeof deleteReportedGroupSchema>;

export const dismissReportSchema = z.object({
	note: z.string().trim().max(500).optional(),
});
export type DismissReportPayload = z.infer<typeof dismissReportSchema>;
